import styled, { css } from 'styled-components';
import { layout } from 'styles/layout'

export interface BannerContainerProps {
  textPosition: 'left' | 'right';
}

const leftPositionedTextCss = css`
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "home-content home-phone";
`;

const rightPositionedTextCss = css`
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "home-phone home-content";
`;

export const BannerContainer = styled.div<BannerContainerProps>`
  overflow: hidden;
  max-width: 1260px !important;
  justify-self: center;
  display: grid;
  column-gap: 50px;
  padding: 5em 3em 11em 4em;
  box-sizing: border-box;

  ${({ textPosition }) => textPosition === 'left' ? leftPositionedTextCss : rightPositionedTextCss};

  @media all and (max-width: 950px) {
    column-gap: 32px;
    padding: 4em 3em 8em 3em;
  }
  
  @media all and (max-width: 800px) {
    grid-template-columns: 1fr;
    row-gap: 2em;
    padding: 0.75em 1.5em 8em 1.5em;
    grid-template-areas: "home-content" "home-phone";
  }
`

export const FluidImageContainer = styled.div`
  width: 110%;
  margin: 0 auto 0 -10%;
  padding-top: 10%;
  max-width: initial;

  @media screen and (max-width: ${layout.subMd}) {
    margin: 0 auto 0 -5%;
  }
`

export const BannerImageContainer = styled.div`
  position: relative;
  align-self: center;

  @media all and (max-width: ${layout.subMd}) {
    max-width: 400px;
    justify-self: center;
    width: 100%;
  }
`
